import { makeStyles } from '@mui/styles';
const commonLinkStyles = makeStyles(({ palette, breakpoints }) => ({
    text: {
        color: palette.primary.light,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% calc(100% - 1px)',
        backgroundSize: '300% 1px',
        letterSpacing: '1.25006px',
        transition: 'background-image .3s,background-size .3s',
        '&:hover': {
            backgroundSize: '100% 1px',
            backgroundImage: 'linear-gradient(270deg,rgba(188,132,32,0),#bc8420 50%,rgba(188,132,32,0))',
        },
        // TODO fix guidance linting error forbidden-style-keys
        // eslint-disable-next-line @dxp-module/guidance/forbidden-style-keys
        fontSize: 18,
        [breakpoints.down('md')]: {
            // TODO fix guidance linting error forbidden-style-keys
            // eslint-disable-next-line @dxp-module/guidance/forbidden-style-keys
            fontSize: 12,
        },
        [breakpoints.down('sm')]: {
            // TODO fix guidance linting error forbidden-style-keys
            // eslint-disable-next-line @dxp-module/guidance/forbidden-style-keys
            fontSize: 18,
        },
    },
    underline: {
        backgroundImage: `linear-gradient(270deg,${palette.primary.light},${palette.primary.light} 50%,${palette.primary.light})`,
    },
    center: {
        backgroundPositionY: 'center',
        [breakpoints.down('sm')]: {
            // TODO fix guidance linting error forbidden-style-keys
            // eslint-disable-next-line @dxp-module/guidance/forbidden-style-keys
            fontSize: 12,
        },
    },
    disabled: {
        pointerEvents: 'none',
        cursor: 'not-allowed',
    },
}), { name: 'Common_CommonLink' });
export default commonLinkStyles;
//# sourceMappingURL=commonLink.styles.js.map